module.exports = __webpack_public_path__ + "img/icon-market.5c1e0bc1.svg";